import { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { formatDate, formatEuro } from "../../lib/format";
import PageHeader from "../../components/PageHeader";
import { RiepilogoSegnalatoriPanel } from "../../components/RiepilogoSegnalatoriPanel";
import { SEG_GEST_RESTORE } from "../../components/SegnalatoreGestioneDialog";
import { Euro, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Contabilita() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(() => (sessionStorage.getItem(SEG_GEST_RESTORE) ? "segnalatori" : "fatture"));

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/studio/fatture"); setRows(data); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const del = async (f) => {
    if (!window.confirm(`Eliminare la fattura n. ${f.numero}?`)) return;
    try { await api.delete(`/studio/fatture/${f.id}`); setRows((x) => x.filter((i) => i.id !== f.id)); toast.success("Fattura eliminata"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const totEmesso = rows.reduce((s, f) => s + Number(f.totale || 0), 0);

  return (
    <div data-testid="contabilita-page">
      <PageHeader
        title="Contabilità"
        subtitle="Registro delle fatture / parcelle emesse per le pratiche."
        icon={Euro}
      />

      <div className="flex gap-1 mb-4 border-b border-slate-800" data-testid="contabilita-tabs">
        {[["fatture", "Fatture"], ["segnalatori", "Riepilogo Segnalatori"]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setTab(k)} data-testid={`conta-tab-${k}`}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${tab === k ? "border-amber-500 text-amber-400" : "border-transparent text-slate-400 hover:text-slate-200"}`}>
            {l}
          </button>
        ))}
      </div>

      {tab === "segnalatori" ? (
        <RiepilogoSegnalatoriPanel />
      ) : (
      <>
      <div className="grid sm:grid-cols-3 gap-4 mb-4">
        <div className="pgp-card p-5">
          <div className="text-xs uppercase tracking-wider text-slate-500 font-mono">Fatture emesse</div>
          <div className="text-2xl font-head font-extrabold text-slate-50 mt-1" data-testid="conta-count">{rows.length}</div>
        </div>
        <div className="pgp-card p-5 sm:col-span-2">
          <div className="text-xs uppercase tracking-wider text-slate-500 font-mono">Totale emesso</div>
          <div className="text-2xl font-head font-extrabold text-emerald-400 mt-1 font-mono" data-testid="conta-totale">{formatEuro(totEmesso)}</div>
        </div>
      </div>

      <div className="pgp-card overflow-x-auto pgp-fade-up">
        {loading ? (
          <div className="p-10 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-amber-500" /></div>
        ) : rows.length === 0 ? (
          <div className="p-10 text-center text-slate-400 text-sm">Nessuna fattura emessa. Emetti una fattura dalla scheda pratica (toolbar Assistito → Fattura).</div>
        ) : (
          <table className="w-full text-sm" data-testid="fatture-table">
            <thead>
              <tr className="text-left text-slate-500 text-xs uppercase tracking-wider font-mono border-b border-slate-800">
                <th className="px-5 py-3">N. Fattura</th>
                <th className="px-5 py-3">Data</th>
                <th className="px-5 py-3">Pratica</th>
                <th className="px-5 py-3">Intestatario</th>
                <th className="px-5 py-3 text-right">Imponibile</th>
                <th className="px-5 py-3 text-right">IVA</th>
                <th className="px-5 py-3 text-right">Totale</th>
                <th className="px-5 py-3 text-right">Azioni</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800">
              {rows.map((f) => (
                <tr key={f.id} className="hover:bg-slate-800/40 transition-colors" data-testid={`fattura-row-${f.id}`}>
                  <td className="px-5 py-3.5 font-mono text-amber-400">{f.numero}</td>
                  <td className="px-5 py-3.5 text-slate-400 font-mono text-xs">{formatDate(f.data)}</td>
                  <td className="px-5 py-3.5 font-mono text-slate-300">{f.pratica_numero || "—"}</td>
                  <td className="px-5 py-3.5 text-slate-100">{f.intestatario || "—"}</td>
                  <td className="px-5 py-3.5 text-right font-mono text-slate-300">{formatEuro(f.imponibile)}</td>
                  <td className="px-5 py-3.5 text-right font-mono text-slate-400">{formatEuro(f.iva)}</td>
                  <td className="px-5 py-3.5 text-right font-mono text-emerald-400 font-semibold">{formatEuro(f.totale)}</td>
                  <td className="px-5 py-3.5 text-right">
                    <button onClick={() => del(f)} data-testid={`fattura-del-${f.id}`} className="text-red-400 hover:text-red-300"><Trash2 className="h-4 w-4" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      </>
      )}
    </div>
  );
}
